import { defineMessage } from 'react-intl';

export const academiaCommonI18n = {
  postSecondary: defineMessage({
    id: 'common:academia.post-secondary',
    defaultMessage: 'Post-secondary'
  }),
  kindergarten: defineMessage({
    id: 'common:academia.kindergarten',
    defaultMessage: 'Kindergarten'
  }),
  primary: defineMessage({
    id: 'common:academia.primary',
    defaultMessage: 'Primary'
  }),
  secondary: defineMessage({
    id: 'common:academia.secondary',
    defaultMessage: 'Secondary'
  })
};
